const AuthConfiguration = {
  authority: 'http://localhost:5000',
  clientId: 'local-control.revers.io',
  scope: 'openid email api',
};

export default AuthConfiguration;
